export default "__VITE_ASSET__DhehZ1Lk__"